const ktTouchEvents = ( 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch ) ? true : false;

// main header ( controlls all things heaader & menu related, including sidebar drawer connections ) 

class MainHeader extends HTMLElement {

	constructor() {
		super();
		this._headerWrapper = document.getElementById('header-container');
		this._lastFittingWidth = window.innerWidth;
		this.mount();
	}

	mount(){

		// add inert elements

		document.querySelectorAll('#main > div').forEach(elm=>{
			if ( ! elm.classList.contains('no-inert') ) {
				elm.setAttribute('data-js-inert', '');
			}
		})
		window.inertElems = document.querySelectorAll('[data-js-inert]');

		// drawer connections

		document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
			if ( elm.hasAttribute('aria-controls') ) {
				const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( elm.hasAttribute('data-js-sidebar-handle-direction') ) {
						elmSidebar.setAttribute('data-direction', elm.getAttribute('data-js-sidebar-handle-direction'));
					}
					elmSidebar.show();
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						elmSidebar.show();
						elmSidebar.querySelector('[data-js-close]').focus();
					}
				})
			}
		});

		if ( document.getElementById('site-cart-sidebar') ) {
			this._openCartFromViewcartParam();
		}
		
		// closing drawers

		// Close the current drawer only, not the ones stacked underneath it.
		// Escape is handled once in SidebarDrawer.
		document.querySelector('.kt-site-overlay').addEventListener('click', ()=>{
			SidebarDrawer.liveDrawer()?.hide();
		});

		// resizing drawers

		const rootHeight = document.getElementById('root-height');
		this._writeRootSize = () => {
			this._rootSizeWidth = window.innerWidth;
			this._rootSizeHeight = window.innerHeight;
			this._rootSizeStale = false;
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
				--sidebar-width: ${window.innerWidth}px;
			}`;
		};
		this.RESIZE_SidebarHelper = debounce(()=>{
			// Mobile toolbars change only the height while scrolling; rewriting :root then restyles the whole page mid-scroll, so drawers catch up on open instead.
			if ( window.innerWidth === this._rootSizeWidth && ! document.body.classList.contains('kt-sidebar-opened') ) {
				this._rootSizeStale = window.innerHeight !== this._rootSizeHeight;
				return;
			}
			this._writeRootSize();
		}, 20);
		window.addEventListener('resize', this.RESIZE_SidebarHelper);

		// Measure before writing :root, which restyles the whole page.
		const bodyWidth = document.body.clientWidth;
		this._previousWidth = window.innerWidth;
		this._updateCompactedState();

		window.addEventListener('resize', debounce(()=>{
			const currentWidth = window.innerWidth;
			if ( currentWidth === this._previousWidth ) return;
			this._updateCompactedState();
			this._previousWidth = currentWidth;
		}, 50));

		// sticky header + background color
		const stickyUp = document.body.classList.contains('kt-header-is-sticky-when-scrolling');

		if ( stickyUp ) {
			window.kt_lst = window.scrollY;
			window.kt_lhp = 0;
			window.kt_sot = 0;
			window.kt_sotelm = this.closest('header')
		}

		if ( this._headerWrapper.classList.contains('kt-header-wrapper--sticky') || stickyUp ) {
			const headerSection = this.closest('header');
			const nativeSticky = ! stickyUp && getComputedStyle(headerSection).position === 'sticky';
			let isSticking = null;
			let isScrolling = null;

			const updateStickyClasses = () => {
				const sticking = nativeSticky ? window.scrollY > 0 && headerSection.getBoundingClientRect().top <= 0 : window.scrollY >= headerSection.offsetTop;
				const scrolling = window.scrollY > 100;
				if ( sticking !== isSticking ) {
					isSticking = sticking;
					this._headerWrapper.classList.toggle('kt-header-wrapper--is-sticking', sticking);
				}
				if ( scrolling !== isScrolling ) {
					isScrolling = scrolling;
					this._headerWrapper.classList.toggle('kt-header-wrapper--is-scrolling', scrolling);
				}
			};

			if ( ! stickyUp ) {
				updateStickyClasses();
			}

			let scrollTicking = false;
			window.addEventListener('scroll', () => {
				if (!scrollTicking) {
					scrollTicking = true;
					requestAnimationFrame(() => {

						scrollTicking = false;

						if ( ! stickyUp ) {

							updateStickyClasses();

						} else if ( stickyUp ) {
							let st = window.scrollY;

							if ( st == 0 || st <= window.kt_sot  ) {
								this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking');
								this._headerWrapper.classList.remove('kt-header-wrapper--is-animating');
							}

							if ( st < 0 || Math.abs(kt_lst - st) <= 5 ) {
								return;	
							}

							if ( st > window.kt_lhp && st > window.kt_sot ) {
								if ( st == 0 && this._headerWrapper.classList.contains('kt-header-wrapper--is-sticking') ) {
									this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking')
									this._headerWrapper.classList.remove('kt-header-wrapper--is-animating');
								} else if ( st <= kt_lst && ! this._headerWrapper.classList.contains('kt-header-wrapper--is-sticking') ) {
									window.kt_lhp = this._headerWrapper.offsetTop;
									if ( Math.abs(this._headerWrapper.getBoundingClientRect().top) > this._headerWrapper.offsetHeight ) {
										window.kt_sot = window.kt_sotelm.offsetTop > 0 ? window.kt_sotelm.offsetTop : window.kt_sot;
										this._headerWrapper.classList.add('kt-header-wrapper--is-sticking');
										this._headerWrapper.classList.add('kt-header-wrapper--is-animating');
									}
								} else if ( st > kt_lst && this._headerWrapper.classList.contains('kt-header-wrapper--is-sticking') ) {
									this._headerWrapper.classList.remove('kt-header-wrapper--is-sticking');
									this._headerWrapper.classList.remove('kt-header-wrapper--is-animating');
								}
								
							}

							window.kt_lst = st;
							
						}

					});
				}
			}, { passive: true });
		}

		const fullHeader = document.getElementById('shopify-section-header');
		if ( fullHeader ) {
			fullHeader.querySelectorAll('.kt-localization-form__item-button').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					fullHeader.querySelectorAll('.kt-localization-form__item-button.kt-active').forEach(elm=>{
						elm.classList.remove('kt-active');
					});
					elm.classList.add('kt-active');
					window.ktMenu.updateHeaderState();
				})
			});

			fullHeader.querySelectorAll('.kt-menu__link, .kt-logo, .kt-localization-form__item-button').forEach(elm=>{
				elm.addEventListener('mouseenter', ()=>{
					window.ktMenu.closeAll({ exceptEl: elm, includeChain: true, closeLocalization: false });
				})
			});

			if ( ! ktTouchEvents ) {
				fullHeader.addEventListener('mouseleave', ()=>{
					window.ktMenu.closeAll({ exceptEl: null, includeChain: true, closeLocalization: false });
				});
			}
		}

		// predictive search

		if ( document.getElementById('shopify-features') && JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {

			document.querySelectorAll('[data-js-open-search-drawer').forEach(elm=>{
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( ! document.body.classList.contains('predictive-script-loaded') ) {
						document.body.classList.add('predictive-script-loaded')
						const predictiveSearchJS = document.createElement('script');
						predictiveSearchJS.src = KROWN.settings.predictive_search_script;
						document.head.appendChild(predictiveSearchJS); 
						const searchDrawerContentJS = document.createElement('script');
						searchDrawerContentJS.src = KROWN.settings.search_drawer_content_script;
						document.head.appendChild(searchDrawerContentJS); 
					}
					setTimeout(()=>{
						document.querySelector('#site-search-sidebar input[type="search"]').focus();
					}, 200)
				});
			});

		} else {

			this.querySelector('search-form')?.addEventListener('click', e=>{
				e.preventDefault();
				window.location.href = KROWN.settings.routes.search_url;
			});

		}

		this._rootSizeWidth = window.innerWidth;
		this._rootSizeHeight = window.innerHeight;
		rootHeight.innerHTML = `:root {
			--window-height: ${window.innerHeight}px;
			--window-width: ${bodyWidth}px;
		}`;
		document.body.classList.add('kt-header-loaded');

		this._bindHeaderPadding();

	}

	unmount(){
		window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		if ( this._updateHeaderPadding ) {
			window.removeEventListener('pageshow', this._updateHeaderPadding);
		}
		this._headerPaddingObserver?.disconnect();
		this._headerPaddingObserver = null;
	}

	_openCartFromViewcartParam() {

		if ( document.body.classList.contains('template-cart') ) {
			return;
		}

		const url = new URL(window.location.href);
		if ( ! url.searchParams.has('viewcart') ) {
			return;
		}

		// Drop the param so a refresh or a shared link doesn't reopen the drawer.
		url.searchParams.delete('viewcart');
		history.replaceState(null, '', url);

		const open = () => {
			document.getElementById('site-cart-sidebar')?.show?.();
		};

		if ( customElements.get('sidebar-drawer') ) {
			open();
			return;
		}

		customElements.whenDefined('sidebar-drawer').then(open);
	}

	_bindHeaderPadding() {
		if ( this._updateHeaderPadding ) {
			window.removeEventListener('pageshow', this._updateHeaderPadding);
		}
		this._updateHeaderPadding = e => {
			if ( e?.type === 'pageshow' && ! e.persisted ) return;
			window.KROWN?.functions?.updateHeaderPadding?.();
		};
		window.addEventListener('pageshow', this._updateHeaderPadding);

		const headerEl = document.getElementById('header-element');
		if ( headerEl && 'ResizeObserver' in window ) {
			this._headerPaddingObserver?.disconnect();
			this._headerPaddingObserver = new ResizeObserver(this._updateHeaderPadding);
			this._headerPaddingObserver.observe(headerEl);
		} else {
			this._updateHeaderPadding();
			document.fonts?.ready?.then(this._updateHeaderPadding);
		}
	}
	
	_updateCompactedState() {
		const header = this;
		const cells = header.querySelectorAll('.kt-header__cell');
		
		if (!cells.length) return;
	
		const headerRect = header.getBoundingClientRect();
		const availableWidth = headerRect.width;
	
		if (!this.classList.contains('kt-js-header--show-compacted')) {
			let minLeft = Infinity;
			let maxRight = -Infinity;
	
			cells.forEach((cell) => {
				const rect = cell.getBoundingClientRect();
				if (!rect.width) return;
				if (rect.left < minLeft) minLeft = rect.left;
				if (rect.right > maxRight) maxRight = rect.right;
			});
	
			if (!isFinite(minLeft) || !isFinite(maxRight)) return;
	
			const usedWidth = maxRight - minLeft;
	
			if (usedWidth <= availableWidth + 1) {
				this._lastFittingWidth = availableWidth;
				this.classList.remove('kt-js-header--show-compacted');
			} else {
				this.classList.add('kt-js-header--show-compacted');
			}
	
		} else {
			if (this._lastFittingWidth && availableWidth >= this._lastFittingWidth) {
				this.classList.remove('kt-js-header--show-compacted');
			}
		}
	}

}

customElements.define('main-header', MainHeader);

// sidebar drawer class ( used for all drawers within the theme )

class SidebarDrawer extends HTMLElement {

	static escBound = false;

	constructor(){
		super();
		this.querySelector('[data-js-close]').addEventListener('click', ()=>{
			this.hide();
		});
		// One shared Escape handler — per-instance listeners would close the next
		// drawer in the same keydown after hide() clears its inert.
		if ( ! SidebarDrawer.escBound ) {
			SidebarDrawer.escBound = true;
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					SidebarDrawer.liveDrawer()?.hide();
				}
			});
		}
	}

	refreshLayoutAfterOpen() {
		const sliders = [...this.querySelectorAll('css-slider')].filter(slider => slider.sliderEnabled);
		if ( sliders.length ) customElements.get('css-slider').resetAll(sliders);
		const imgs = [...this.querySelectorAll('img[data-ratio]')];
		const sizes = imgs.map(img => [img.offsetWidth, img.offsetHeight]);
		imgs.forEach((img, i) => KROWN.functions.setImagesize(img, ...sizes[i]));
	}

	show(){

		// The header renders one handle per breakpoint, so all of them track the state.
		document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(elm=>elm.setAttribute('aria-expanded', 'true'));

		if ( this.id == 'site-cart-sidebar' ) {
			KROWN.functions.eventDispatcher('krown:cart-sidebar:show', {
				sidebarElement: document.getElementById('site-cart-sidebar')
			});
		}

		const mainHeader = document.querySelector('main-header');
		if ( mainHeader?._rootSizeStale ) {
			mainHeader._writeRootSize();
		}

		this._opened = true;
		document.body.classList.add('kt-sidebar-opened');
		document.body.classList.add('kt-sidebar-opened-set-header-index');
		if ( this.dataset.direction == 'right' ) {
			document.body.classList.add('kt-sidebar-opened--right');
		} else if ( this.dataset.direction== 'left' ) {
			document.body.classList.add('kt-sidebar-opened--left');
		}
		this.style.display = 'grid';
		window.KROWN.previouslyFocused = document.activeElement;
		setTimeout(()=>{
			this.classList.add('kt-sidebar--opened');
			window.inertElems.forEach(elm=>{
				elm.setAttribute('inert', '');
			});
			// At most one drawer is interactive at a time, so this covers that one and
			// keeps a reference to it — closing restores it without touching drawers
			// deeper in the stack.
			this._covered = SidebarDrawer.liveDrawer(this);
			this._covered?.setAttribute('inert', '');
			this.removeAttribute('inert');
		}, 15);

		setTimeout(()=>{
			if ( ! this._opened ) return;
			this.refreshLayoutAfterOpen();
		}, document.body.classList.contains('touchevents') ? 255 : 50);

		setTimeout(()=>{
			if ( this.querySelector('[data-js-close]') ) {
				this.querySelector('[data-js-close]').focus();
			}
		}, 120);

	}

	hide(){

		this._opened = false;
		this.classList.remove('kt-sidebar--opened');
		this.removeAttribute('inert');

		// Hand interactivity back to whatever this drawer covered.
		if ( this._covered?._opened ) {
			this._covered.removeAttribute('inert');
		}
		this._covered = null;

		// The overlay, scroll lock and page inert belong to the whole drawer stack,
		// so only tear them down once nothing is left open behind this drawer.
		const stillOpen = SidebarDrawer.openedDrawers();

		document.body.classList.remove('kt-sidebar-opened--left');
		document.body.classList.remove('kt-sidebar-opened--right');
		stillOpen.forEach(drawer=>{
			if ( drawer.dataset.direction == 'right' ) {
				document.body.classList.add('kt-sidebar-opened--right');
			} else if ( drawer.dataset.direction == 'left' ) {
				document.body.classList.add('kt-sidebar-opened--left');
			}
		})

		if ( ! stillOpen.length ) {
			document.body.classList.remove('kt-sidebar-opened');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})
		}

		if ( window.KROWN.previouslyFocused ) {
			window.KROWN.previouslyFocused.focus();
			window.KROWN.previouslyFocused = null;
		}

		document.querySelectorAll(`[aria-controls="${this.id}"]`).forEach(elm=>elm.setAttribute('aria-expanded', 'false'));

		if ( this.id == 'site-cart-sidebar' ) {
			KROWN.functions.eventDispatcher('krown:cart-sidebar:hide', {
				sidebarElement: document.getElementById('site-cart-sidebar')
			});
		}

		setTimeout(()=>{
			this.style.display = 'none';
		}, 360);

		setTimeout(()=>{
			if ( ! SidebarDrawer.openedDrawers().length ) {
				document.body.classList.remove('kt-sidebar-opened-set-header-index');
			}
		}, 220);

	}

	static openedDrawers(){
		return [...document.querySelectorAll('sidebar-drawer')].filter(drawer=>drawer._opened);
	}

	// The drawer the shopper can actually interact with: everything stacked below it is inert.
	static liveDrawer(except){
		return SidebarDrawer.openedDrawers().find(drawer=>drawer !== except && ! drawer.hasAttribute('inert')) || null;
	}

}

customElements.define('sidebar-drawer', SidebarDrawer);

// central controller function & class for the menu

function ktUpdateHeaderWrapperState() {
  const header = document.querySelector('.kt-header-wrapper');
  if (!header) return;

	const hasOpened = document.querySelector(
    'item-is-dropdown.kt-active, .kt-menu__submenu.kt-opened, item-is-megamenu .kt-megamenu.kt-opened, .kt-localization-form__item-button.kt-active'
  );

  const hasSubmenuOpened = document.querySelector('.kt-menu__submenu.kt-opened');
  const hasMegaOpened = document.querySelector('item-is-megamenu .kt-megamenu.kt-opened');

  header.classList.toggle('kt-header-wrapper--has-opened-items', !!hasOpened);
  header.classList.toggle('kt-header-wrapper--has-opened-submenu', !!hasSubmenuOpened);
  header.classList.toggle('kt-header-wrapper--has-opened-megamenu', !!hasMegaOpened);
}

class KtMenuController {
  constructor() {
    this.headerSelector = '.kt-header-wrapper';

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    document.addEventListener('click', this.handleDocumentClick);
  }

  get header() {
    return document.querySelector(this.headerSelector);
  }

  updateHeaderState() {
    ktUpdateHeaderWrapperState();
  }

  buildKeepSet(exceptEl, includeChain = true) {
    const keep = new Set();
    if (!exceptEl) return keep;

    if (includeChain && exceptEl.closest) {
      let node = exceptEl;
      while (node) {
        if (node.matches?.('item-is-dropdown, item-is-megamenu')) {
          keep.add(node);
        }
        node = node.parentElement;
      }
    } else {
      keep.add(exceptEl);
    }

    return keep;
  }

  closeAll({ exceptEl = null, includeChain = true, closeLocalization = true } = {}) {
    const keep = this.buildKeepSet(exceptEl, includeChain);

    const shouldSkip = (el) => {
      if (!exceptEl) return false;
      for (const k of keep) {
        if (k.contains(el)) return true;
      }
      return false;
    };

    document.querySelectorAll('item-is-dropdown.kt-active').forEach(host => {
      if (shouldSkip(host)) return;
      host.classList.remove('kt-active');
      host.setAttribute('aria-expanded', 'false');
    });

    document.querySelectorAll('.kt-menu__submenu.kt-opened').forEach(ul => {
      if (shouldSkip(ul)) return;
      ul.classList.remove('kt-opened', 'kt-menu__submenu--flip');
      ul.style.removeProperty('--submenu-nudge-x');
      ul.style.removeProperty('--submenu-nudge-y');
    });

		if ( closeLocalization ) {
			document.querySelectorAll('.kt-localization-form__item-button.kt-active').forEach(elm=>{
				elm.classList.remove('kt-active');
				elm.setAttribute('aria-expanded', 'false');
				elm.closest('.kt-localization-form__item').querySelector('.kt-localization-form__content').classList.remove('kt-content-opened');
				elm.closest('.kt-localization-form__item').querySelector('.kt-localization-form__content').style.zIndex = 9;
			});
		}

    document.querySelectorAll('item-is-megamenu').forEach(mm => {
      if (shouldSkip(mm)) return;

      const menu = mm.querySelector('.kt-megamenu.kt-opened');
      const link = mm.querySelector('.kt-menu__link.kt-active');

      if (menu) menu.classList.remove('kt-opened');
      if (link) link.classList.remove('kt-active');

      mm.setAttribute('aria-expanded', 'false');
      mm.querySelector('.kt-menu__caret, button.kt-menu__link')?.setAttribute('aria-expanded', 'false');
    });

    this.updateHeaderState();
  }

  handleDocumentClick(e) {
    if (e.target.closest('item-is-dropdown, item-is-megamenu')) return;
    this.closeAll();
  }
}

window.ktMenu = window.ktMenu || new KtMenuController();

// base class for shared helpers

class KtBaseMenuItem extends HTMLElement {
  getSubmenu() {
    return this.querySelector(':scope > .kt-menu__submenu, .kt-menu__submenu');
  }

  getTrigger() {
    return this.querySelector(
      ':scope > .kt-menu__link, :scope > .kt-menu__toggle, :scope > [aria-haspopup="true"]'
    );
  }

  setExpanded(open) {
    this.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  updateHeader() {
    window.ktMenu.updateHeaderState();
  }

  closeDescendants() {
    this.querySelectorAll('item-is-dropdown.kt-active').forEach(host => {
      host.classList.remove('kt-active');
      host.setAttribute('aria-expanded', 'false');
    });
    this.querySelectorAll('.kt-menu__submenu.kt-opened').forEach(ul => {
      ul.classList.remove('kt-opened', 'kt-menu__submenu--flip');
      ul.style.removeProperty('--submenu-nudge-x');
      ul.style.removeProperty('--submenu-nudge-y');
    });
  }
}

// item-is-dropdown class ( used for all dropdowns in the classic header menu )

class itemIsDropdown extends KtBaseMenuItem {
	constructor() {
		super();
		this.onSelfClick = this.onSelfClick.bind(this);
		this.onSelfKeydown = this.onSelfKeydown.bind(this);
		this.handleMouseEnter = this.onSelfMouseEnter.bind(this);
	}

	connectedCallback() {
		this.addEventListener('click', this.onSelfClick);
		this.addEventListener('keydown', this.onSelfKeydown);
		if ( ! ktTouchEvents ) {
			this.addEventListener('mouseenter', this.handleMouseEnter);
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onSelfClick);
		this.removeEventListener('keydown', this.onSelfKeydown);
		if ( ! ktTouchEvents ) {
			this.removeEventListener('mouseenter', this.handleMouseEnter);
		}
	}

	// keyboard activation: the trigger is an <a href="…">, so on desktop a click
	// no longer preventDefaults ( hover opens, click navigates ). Enter/Space must
	// still open the submenu for keyboard users, so handle them explicitly here.
	onSelfKeydown(e) {
		console.log(e.keyCode);
		if ( e.keyCode !== window.KEYCODES.RETURN ) return;

		const trigger = this.getTrigger();
		const target = e.target.closest('.kt-menu__link, .kt-menu__toggle, [aria-haspopup="true"]');

		// only act on this item's own trigger — let nested items handle their own keys
		if ( ! target || ( trigger && ! trigger.contains(target) ) ) return;

		e.preventDefault();
		e.stopPropagation();

		if ( this.classList.contains('kt-active') ) {
			this.setOpenState(false);
		} else {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.setOpenState(true);
		}
	}

	onSelfMouseEnter(e) {
		e.preventDefault();
		e.stopPropagation();
		if ( ! this.classList.contains('kt-active') ) {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.setOpenState(true);
		}
	}

	setOpenState(open, el = this) {
		el.classList.toggle('kt-active', open);
		this.setExpanded(open);

		const submenu = this.getSubmenu();
		if (submenu) {
			if (open) {
				document.querySelectorAll('.kt-menu__submenu--level-2.kt-opened').forEach(ul => {
					ul.classList.remove('kt-opened', 'kt-menu__submenu--flip');
					ul.style.removeProperty('--submenu-nudge-x');
					ul.style.removeProperty('--submenu-nudge-y');

					const host = ul.closest('item-is-dropdown');
					if (host) {
						host.classList.remove('kt-active');
						host.setAttribute('aria-expanded', 'false');
					}
				});
			} else {
				this.closeDescendants();
			}

			submenu.classList.toggle('kt-opened', open);
			if (open) {
				this.adjustSubmenuPosition(submenu);
			} else {
				submenu.classList.remove('kt-menu__submenu--flip');
				submenu.style.removeProperty('--submenu-nudge-x');
				submenu.style.removeProperty('--submenu-nudge-y');
			}
		} else if (!open) {
			this.closeDescendants();
		}

		this.updateHeader();
	}

	onSelfClick(e) {
		const submenu = this.getSubmenu();

		if (submenu && submenu.contains(e.target)) {
			const wantsClose = e.target.closest('[data-close-submenu]');
			if (wantsClose) {
				e.preventDefault();
				e.stopPropagation();
				this.setOpenState(false);
			}
			return;
		}

		const trigger = this.getTrigger();
		const clickedTrigger = e.target.closest(
			'.kt-menu__link, .kt-menu__toggle, [aria-haspopup="true"]'
		);
		if (!clickedTrigger || (trigger && !trigger.contains(clickedTrigger))) return;

		e.stopPropagation();
		if ( ktTouchEvents ) {
			e.preventDefault();
		}

		const isActive = this.classList.contains('kt-active');

		if (isActive) {
			this.setOpenState(false);
		} else {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.setOpenState(true);
		}
	}

	adjustSubmenuPosition(submenu) {
		submenu.classList.remove('kt-menu__submenu--flip');
		submenu.style.removeProperty('--submenu-nudge-x');
		submenu.style.removeProperty('--submenu-nudge-y');

		const vw = window.innerWidth;
		const vh = window.innerHeight;
		const hostRect = this.getBoundingClientRect();
		const spaceRight = vw - hostRect.right;
		const spaceLeft = hostRect.left;

		let rect = submenu.getBoundingClientRect();
		const needFlip = rect.width > spaceRight && spaceLeft >= spaceRight;

		submenu.classList.toggle('kt-menu__submenu--flip', needFlip);
		rect = submenu.getBoundingClientRect();

		let nudgeX = 0;
		if (rect.left < 0) nudgeX = -rect.left;
		else if (rect.right > vw) nudgeX = vw - rect.right;

		let nudgeY = 0;
		if (rect.top < 0) nudgeY = -rect.top;
		else if (rect.bottom > vh) nudgeY = vh - rect.bottom;

		if (nudgeX !== 0) submenu.style.setProperty('--submenu-nudge-x', `${Math.round(nudgeX)}px`);
		if (nudgeY !== 0) submenu.style.setProperty('--submenu-nudge-y', `${Math.round(nudgeY)}px`);
	}

}

customElements.define('item-is-dropdown', itemIsDropdown);

// item-is-megamenu class ( used for all megamenus in the classic header menu )

class itemIsMegamenu extends KtBaseMenuItem {
	constructor() {
		super();
		this.handleClick = this.handleClick.bind(this);
		this.handleKeydown = this.handleKeydown.bind(this);
		this.handleMouseEnter = this.handleMouseEnter.bind(this);
	}

	connectedCallback() {
		this.link = this.querySelector('.kt-menu__link');
		this.caret = this.querySelector('.kt-menu__caret');
		const template = this.querySelector('template[data-megamenu-template]');
		if (template) {
			template.replaceWith(document.importNode(template.content, true));
		}
		this.menu = this.querySelector('.kt-megamenu');
		if (!this.link || !this.menu) return;

		this.setExpanded(false);
		// With a landing-page link, the title navigates and the caret uses the same toggle.
		// Touch has no hover, so there the title keeps toggling the menu instead of navigating.
		(this.caret && ! ktTouchEvents ? this.caret : this.link).addEventListener('click', this.handleClick);
		if ( ! this.caret ) {
			this.link.addEventListener('keydown', this.handleKeydown);
		}
		if ( ! ktTouchEvents ) {
			this.link.addEventListener('mouseenter', this.handleMouseEnter);
		}
	}

	disconnectedCallback() {
		if (this.caret) {
			this.caret.removeEventListener('click', this.handleClick);
		}
		if (this.link) {
			this.link.removeEventListener('click', this.handleClick);
			this.link.removeEventListener('keydown', this.handleKeydown);
			if ( ! ktTouchEvents ) {
				this.link.removeEventListener('mouseenter', this.handleMouseEnter);
			}
		}
	}

	setExpanded(open) {
		super.setExpanded(open);
		const state = open ? 'true' : 'false';
		if (this.caret) {
			this.caret.setAttribute('aria-expanded', state);
		} else if (this.link && this.link.tagName === 'BUTTON') {
			this.link.setAttribute('aria-expanded', state);
		}
	}

	// the trigger is a button.kt-menu__link — handle keyboard activation explicitly.
	handleKeydown(e) {
		if ( e.keyCode !== window.KEYCODES.RETURN ) return;
		this.handleClick(e);
	}

	handleMouseEnter(e) {
		e.preventDefault();
		e.stopPropagation();
		if ( ! this.menu.classList.contains('kt-opened') ) {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.open();
		}
	}

	handleClick(e) {
		e.preventDefault();
		e.stopPropagation();

		const willOpen = !this.menu.classList.contains('kt-opened');

		if (willOpen) {
			window.ktMenu.closeAll({ exceptEl: this, includeChain: true });
			this.open();
		} else {
			this.close();
		}
	}

	open() {
		this.menu.classList.add('kt-opened');
		if (this.link) {
			this.link.classList.add('kt-active');
		}
		this.setExpanded(true);
		this.updateHeader();
	}

	close() {
		this.menu.classList.remove('kt-opened');
		if (this.link) {
			this.link.classList.remove('kt-active');
		}
		this.setExpanded(false);

		this.closeDescendants();

		this.updateHeader();
	}
}

customElements.define('item-is-megamenu', itemIsMegamenu);
class AccountButton extends HTMLElement {
	connectedCallback() {
		this.addEventListener('pointerenter', event => {
			if ( event.pointerType === 'mouse' && this.isConnected ) this.#mount();
		});
		this.querySelector('button').addEventListener('click', () => this.#open(this.#mount()));
	}

	#mount() {
		const account = document.importNode(this.querySelector('template').content, true).querySelector('shopify-account');
		// A click that lands before Shopify renders its button would otherwise do nothing.
		account.addEventListener('click', () => {
			if ( ! account.shadowRoot?.querySelector('.account-button') ) this.#open(account);
		}, { once: true });
		this.replaceWith(account);
		return account;
	}

	async #open(account) {
		await customElements.whenDefined('shopify-account');
		let button;
		for ( let tries = 0; tries < 100 && ! ( button = account.shadowRoot?.querySelector('.account-button') ); tries++ ) {
			await new Promise(resolve => setTimeout(resolve, 50));
		}
		button?.focus();
		button?.click();
	}
}

customElements.define('account-button', AccountButton);
